import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckSelectors, DckActionCreators } from "dck-redux"

import { ActionCreators } from "../../../redux/actions"
import * as ItemTypes from "../../../redux/items/types"
import ProcessTypes from "../../../redux/processes/types"
import UserForm from "../UserForm"

class EditUser extends Component {

  componentDidMount() {
    const { loadUsers, loadUserRoles } = this.props
    loadUsers()
    loadUserRoles()
  }

  render() {

    const { currentUser, userRoles, userLocales, resetUserPassword, failed, 
      running, success, error, saveUser } = this.props

    return (
      <div>
        { currentUser ?
          <UserForm
            id="editUserForm"
            user={ currentUser }
            onSaveClicked={data => saveUser(currentUser.id, data)}
            userRoles={ userRoles }
            locales={ userLocales }
            resetUserPassword={() => resetUserPassword(currentUser.id)}
            failed={ failed }
            running={ running }
            success={ success }
            error={ error }
          />
        : null
        }
      </div>
    )
  }
}

EditUser.propTypes = {
  userRoles: PropTypes.array.isRequired,
  userLocales: PropTypes.array.isRequired,
  saveUser: PropTypes.func.isRequired,
  loadUserRoles: PropTypes.func.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const mapping = {

    runningUpdate: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.USERS_UPDATE
    ),

    failedUpdate: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.USERS_UPDATE
    ),

    successUpdate: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.USERS_UPDATE
    ),

    resultUpdate: DckSelectors.selectProcess(
      state,
      ProcessTypes.USERS_UPDATE
    ),

    currentUser: DckSelectors.selectItemById(
      state,
      ItemTypes.User,
      ownProps.params.id
    ),

    userRoles: DckSelectors.selectAllItems(state, ItemTypes.UserRole),

    userLocales: DckSelectors.selectAllItems(state, ItemTypes.UserLocale),

    runningPassword: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.RESET_USER_PASSWORD
    ),

    failedPassword: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.RESET_USER_PASSWORD
    ),

    successPassword: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.RESET_USER_PASSWORD
    ),

    resultPassword: DckSelectors.selectProcess(
      state,
      ProcessTypes.RESET_USER_PASSWORD
    )
  }

  mapping['running'] = mapping.runningUpdate || mapping.runningPassword
  mapping['failed'] = mapping.failedUpdate || mapping.failedPassword
  mapping['error'] = mapping.failedPassword && mapping.resultPassword && mapping.resultPassword.result 
    ? mapping.resultPassword.result.message
    : mapping.failedUpdate && mapping.resultUpdate && mapping.resultUpdate.result 
      ? mapping.resultUpdate.result.message
      : ''

  return mapping
}

const mapDispatchToProps = dispatch => ({
  saveUser: (id, data) => dispatch(DckActionCreators.itemSave(ItemTypes.User, id, data)),
  loadUserRoles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.UserRole)),
  resetUserPassword: id => dispatch(ActionCreators.resetUserPassword(ItemTypes.User, id)),
  loadUsers: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.User))
})

export default connect(mapStateToProps, mapDispatchToProps)(EditUser)



// WEBPACK FOOTER //
// ./src/components/Users/EditUser/index.js